import { render, staticRenderFns } from "./ComputerSection.vue?vue&type=template&id=68a7db84"
import script from "./ComputerSection.vue?vue&type=script&lang=js"
export * from "./ComputerSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports